import { theme } from "@/theme";

export const HEADER_WIDTH = "100%";

export const HEADER_HEIGHT = 64;

export const SIDEBAR_WIDTH = 300;

export const SIDEBAR_HEIGHT = "100%";

export const ERROR_BANNER_HEIGHT = 38;

export const CONTENT_HEIGHT = `calc(100vh - ${HEADER_HEIGHT}px)`;

export const MAIN_SIDEBAR_WIDTH = 95;

export const EXPANDING_SIDEBAR_WIDTH = 240;

export const SECONDARY_SIDEBAR_WIDTH = 280;

export const PROTRUDING_EDGE_WIDTH = 10;

export const SIDEBAR_TRANSITIONS = theme.transitions.create(
  ["margin", "margin-left", "translate", "rotate", "width", "opacity"],
  {
    duration: theme.transitions.duration.short,
    easing: theme.transitions.easing.easeOut,
  }
);

export const LIST_ITEM_ICON_MIN_WIDTH = 24;
